import React, {Component} from "react"

import {TextAreaEmojiPicker, TextReplace} from "../Reactions"
import {EMOJI} from "../Reactions/constants"

interface Props {
  hasError: boolean,
  inputRef?: HTMLInputElement,
  onChange: (value: string) => void,
  textReplaceTypes: string[],
  value: string
}

interface State {
  showFullEmojiPicker: boolean
}

export class RichEditorWrapper extends Component<Props, State> {
  state: State = {
    showFullEmojiPicker: false
  }

  togglePickerModal = () => this.setState((prevState) => ({showFullEmojiPicker: !prevState.showFullEmojiPicker}))

  render() {
    const {hasError, inputRef, onChange, textReplaceTypes, value} = this.props
    const {showFullEmojiPicker} = this.state

    return (
      <>
        {textReplaceTypes.includes(EMOJI) && (
          <TextAreaEmojiPicker
            cursorPosition={inputRef?.selectionStart}
            hasError={hasError}
            onChange={(updatedValue: string) => {
              onChange(updatedValue)
              return inputRef?.focus()
            }}
            showFullEmojiPicker={showFullEmojiPicker}
            togglePickerModal={this.togglePickerModal}
            value={value} />
        )}
        {textReplaceTypes.map((t) => (
          <TextReplace
            cursorPosition={inputRef?.selectionStart}
            key={t}
            onChange={(updatedValue: string) => {
              onChange(updatedValue)
              return inputRef?.focus()
            }}
            showFullEmojiPicker={showFullEmojiPicker}
            type={t}
            value={value} />
        ))}
      </>
    )
  }
}

export default RichEditorWrapper
